import { createMuiTheme, createStyles, createTheme } from "@material-ui/core";

const theme = createTheme ({
    
      root: {
        "&&:hover": {
          backgroundColor: "#daeaf6",
          color: "white"
        }
      },
      selected: { 
        "&&": {
          backgroundColor: "blue",
          color: "white",
          "&& span": {
            color: "white"
          }
        },
        "&&:hover": {
          backgroundColor: "darkblue",
          color: "white"
        }
      },
      
      typography: {
        fontFamily: [
           'sans-serif'
        ],
        h5: {
          fontFamily: 'sans-serif',
        }
      }
    
});

export default theme;
